import { useState, useEffect } from 'react';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { formatCurrencyV2 } from '../common/formatCurrency.ts';
import { addCommas } from '../utils/numberUtils.ts';
import { TrackSectionView } from '../common/TrackSectionView.tsx';

const defaultImpactData = {
    state: '',
    amountRaised: '--',
    projectsFunded: '--',
    teachersSupported: '--',
    donorCount: '--',
    schoolsSupported: '--',
    books: '--',
    artSupplies: '--',
    schoolTrips: '--',
};
export const MarketingImpact = ({ state, totalProjects }) => {
    const [impactData, setImpactData] = useState(defaultImpactData);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const url = `${secureBaseURL}about/impact.json` + (state == null ? '' : '?state=' + state);
        $.ajax({
            type: 'get',
            url,
            cache: true,
            dataType: 'json',
            success: ({ stateName, stats }) => {
                setLoading(false);
                setImpactData({
                    state: stateName !== 'national' ? stateName : '',
                    amountRaised: formatCurrencyV2(stats.dollarsRaised, 'HIDE_CENTS'),
                    projectsFunded: addCommas(stats.projectsFunded),
                    teachersSupported: addCommas(stats.teachersProjectsFunded, false),
                    donorCount: addCommas(stats.supporters, false),
                    schoolsSupported: addCommas(stats.schoolsParticipating, false),
                    books: addCommas(stats.numBookResources, false),
                    artSupplies: addCommas(stats.numArtResources, false),
                    schoolTrips: addCommas(stats.numTripResources, false),
                    projectsSeekingFunding: addCommas(stats.projectsSeekingFunding, false),
                });
            },
        });
    }, []);

    const renderSubheader = () => {
        if (impactData.state) {
            return (<p className="subheader">{impactData.projectsSeekingFunding + ' ' + impactData.state} classrooms are requesting supplies
                through
                DonorsChoose, the most funded classroom funding site for teachers.</p>);
        }
        return (<p className="subheader">{impactData.projectsSeekingFunding} classrooms across the country are requesting supplies through
            DonorsChoose, the most
            funded classroom funding site for teachers.</p>);
    };

    return (
        <div className="impact-stats">
            {loading
                ? <LoadingEllipsis/>
                : <TrackSectionView sectionName={'Impact Stats'}>
                    <h1>Our Impact {impactData.state !== '' ? 'in ' + impactData.state : 'Nationwide'}</h1>
                    {renderSubheader()}
                    <div className="first-metric">
                        <h4>{impactData.amountRaised}</h4>
                        <p>FOR TEACHERS AND STUDENTS</p>
                    </div>
                    <div className="second-metric projects">
                        <h4>{impactData.projectsFunded}</h4>
                        <p>PROJECTS FUNDED</p>
                    </div>
                    <div className="second-metric teachers">
                        <h4>{impactData.teachersSupported}</h4>
                        <p>TEACHERS SUPPORTED</p>
                    </div>
                    <div className="second-metric donors">
                        <h4>{impactData.donorCount}</h4>
                        <p>DONORS</p>
                    </div>
                    <div className="second-metric schools">
                        <h4>{impactData.schoolsSupported}</h4>
                        <p>SCHOOLS SUPPORTED</p>
                    </div>
                    <h3 className="subheader">{impactData.state !== '' ? 'In ' + impactData.state : 'Nationwide'} we've delivered</h3>
                    <div className="second-metric books">
                        <h4>{impactData.books}</h4>
                        <p>BOOKS</p>
                    </div>
                    <div className="second-metric art">
                        <h4>{impactData.artSupplies}</h4>
                        <p>ART SUPPLIES</p>
                    </div>
                    <div className="second-metric class-trips">
                        <h4>{impactData.schoolTrips}</h4>
                        <p>CLASS TRIPS</p>
                    </div>
                </TrackSectionView>}
        </div>);
};
